const getISOWeekDate = (date: Date): Date => {
  const target = new Date(date.getTime());
  target.setHours(0, 0, 0, 0);
  target.setDate(target.getDate() + 3 - ((target.getDay() + 6) % 7)); // Adjust to nearest Thursday
  return target;
};

export const currentWeek = (date: Date): number => {
  const target = getISOWeekDate(date);
  const firstThursday = new Date(target.getFullYear(), 0, 4);
  firstThursday.setDate(
    firstThursday.getDate() + 3 - ((firstThursday.getDay() + 6) % 7)
  );
  const weekNumber = Math.ceil(
    ((target.getTime() - firstThursday.getTime()) / 86400000 + 1) / 7
  );
  return weekNumber;
};

export const currentWeekYear = (date: Date): number =>
  getISOWeekDate(date).getFullYear();
